import script from "./CompanyTableRow.vue?vue&type=script&setup=true&lang=js"
export * from "./CompanyTableRow.vue?vue&type=script&setup=true&lang=js"

import "./CompanyTableRow.vue?vue&type=style&index=0&id=24c41a4f&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-24c41a4f"]])

export default __exports__